export class BufferbloatError extends Error {}
export class LatencySourceNotFoundError extends BufferbloatError {}

